import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import "ag-grid-community/styles/ag-theme-alpine.css";
import DailyReportsServices from '../../services/axiosServices/apiServices/DailyReportsServices';
import SwalServices from '../../services/swalServices/SwalServices';
import { getAuthProps } from '../../utils/AuthenticationLibrary';

// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);

class UserReports extends Component {
    constructor(props) {
        super(props);
        this.dailyReportsServices = new DailyReportsServices();
        this.SwalServices = new SwalServices();
        this.state = {
            rowData: [
                // { name: "John Doe", report_name: "Sales Report", type: "Monthly" },
                // { name: "Jane Smith", report_name: "Financial Report", type: "Quarterly" },
                // { name: "David Lee", report_name: "Marketing Report", type: "Weekly" },
                // { name: "Sarah Jones", report_name: "HR Report", type: "Annual" },
                // { name: "Michael Brown", report_name: "Project Report", type: "Daily" },
            ],
            colDefs: [
                {
                    field: "name",
                    headerName: "Name",
                    filter: true,
                    floatingFilter: true,
                    flex: 1,
                },
                {
                    field: "report_name",
                    headerName: "Report name",
                    filter: true,
                    floatingFilter: true,
                    flex: 1,
                },
                {
                    field: "type",
                    headerName: "Type",
                    filter: true,
                    floatingFilter: true,
                    flex: 1,
                },
            ],
            paginationPageSize: 50,
            rowHeight: 40,
        };
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        if (prop && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany }, () => {
                this.getAvailableReports();
            });
        } else {
            //window.location.href = "/Login";
        }
    }
    getAvailableReports = () => {
        this.dailyReportsServices.getAvailableReports().then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                this.setState({ rowData: response.responseItem.responseContent.length > 0 ? response.responseItem.responseContent : [] });
            }
        });
    }
    usp_Extra_UserFormsInsert = () => {
        let formName = this.state.formName;
        let accessibleName = this.state.accessibleName;
        let request = [formName, accessibleName];
        this.dailyReportsServices.usp_Extra_UserFormsInsert(request).then((response) => {
            //debugger
            if (response.statusCode == 200 && response.responseItem !== null) {
                debugger;
            }
        });
    }

    render() {
        return (
            <div className='user-reports'>
                <div className="data-display relative">
                    <div className="data-display-inner">
                        <div className="table w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[83.65vh] w-full px-[1px] rounded-[5px]">
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">User forms</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='btn-grp absolute top-[-43px] right-[0]'>
                        <button className='update-btn btns'
                            onClick={() => { this.usp_Extra_UserFormsInsert() }}
                        >Save</button>
                    </div>
                </div>
            </div>
        )
    }
}
export default UserReports;